module.exports = __webpack_public_path__ + "static/img/loginbg.20febae9.png";